<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $t('messages.health_amount'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="md:grid md:grid-cols-12 md:gap-6">
            <div class="col-span-6">
                <NavLinks :links="meta.navGroupLinks" />
            </div>
        </div>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <div class="flex justify-end mt-5">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>

            <div class="flex flex-col mt-5">
                <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div
                        class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                    >
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                                <tr>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.student') }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.before') }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.after') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                    v-for="(student, index) in form.students"
                                    :key="student.student_id"
                                >
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        {{ student.full_name }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        {{ student.health_max }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        <FormInput
                                            v-model.number="student.new_health_max"
                                            name="new_health_max"
                                            type="number"
                                            step="1"
                                            min="10"
                                            max="100000"
                                            class="w-full mt-1"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="flex justify-end mt-5">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import AppButton from '@/components/AppButton.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        PanelPage,
        FormInput,
        AppButton,
        NavLinks,
    },
    layout: Layout,
    name: 'Edit',
    props: ['filters', 'meta', 'options', 'students', 'gamificationSet'],
    data() {
        return {
            form: this.$inertia.form({
                students: this.students.map((s) => {
                    return {
                        student_id: s.student_id,
                        full_name: s.full_name,
                        health_max: s.health_max,
                        new_health_max: s.health_max,
                    };
                }),
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update, {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.students = this.students.map((s) => {
                        return {
                            student_id: s.student_id,
                            full_name: s.full_name,
                            health_max: s.health_max,
                            new_health_max: s.health_max,
                        };
                    });
                },
            });
        },
    },
    computed: {},
};
</script>
